import { render, staticRenderFns } from "./addPlate.vue?vue&type=template&id=8fccfe1e&scoped=true&"
import script from "./addPlate.vue?vue&type=script&lang=js&"
export * from "./addPlate.vue?vue&type=script&lang=js&"
import style0 from "./addPlate.vue?vue&type=style&index=0&id=8fccfe1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fccfe1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fccfe1e')) {
      api.createRecord('8fccfe1e', component.options)
    } else {
      api.reload('8fccfe1e', component.options)
    }
    module.hot.accept("./addPlate.vue?vue&type=template&id=8fccfe1e&scoped=true&", function () {
      api.rerender('8fccfe1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/currency/plate/components/addPlate.vue"
export default component.exports